import { TableContainer } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@mui/material/Tooltip";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import React from 'react';
import { useHistory } from "react-router";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    paddingLeft: "20px !important",
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);


const DeceasedTableList = ({
  list,
  loading,
  total,
  setPage,
  setOpenModal,
  setOpen,
  setMournersList,
  setDeceasedId,
  setOpenAddMournerModal,

}) => {
  const history = useHistory();

  const columns = [
    {
      id: "firstName",
      label: "DECEASED FIRST NAME",
    },
    {
      id: "lastName",
      label: "DECEASED LAST NAME",
    },
    {
      id: "date_of_death",
      label: "ENGLISH DEATH DATE",
    },
    {
      id: "eng-mourners",
      label: "ENGLISH MOURNER",
    },
    {
      id: "hebrew_date",
      label: "HEBREW DEATH DATE",
    },
    {
      id: "heb-mourners",
      label: "HEBREW MOURNER",
    },
    {
      id: "plaque_number",
      label: "PLAQUE NUMBER",
    },
    {
      id: "action",
      label: "Action",
      className: "sticky-header-column",
    },
  ];

  return (
    <div
      className="current-class-table-container"
      style={{
        padding: "17px",
      }}
    >
      <div>
        <TableContainer className="scroll-table">
          <Table
            class="main-tables"
            aria-label="collapsible table"
            style={{ width: "100%" }}
          >
            <TableHead className="charges-table sticky-table-header">
              <TableRow>
                {columns?.map((column) => (
                  <TableCellHead
                    key={column.id}
                    align="left" className={`class__header__cell year__head ${column.className}`}
                  >
                    {column?.id !== "action" && (
                      <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}
                      >
                        {column?.label}
                      </div>
                    )}
                  </TableCellHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              className="tran-table-body"
              style={{
                backgroundColor: "white",
              }}
            >
              {loading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <div
                      className="user__loader"
                      style={{ height: "320px" }}
                    >
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : list?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <h6 style={{ height: "320px", marginTop: "100px" }}>
                      No Data Found
                    </h6>
                  </TableCell>
                </TableRow>
              ) : (
                list?.map((row, i) => (
                  <TableRow
                    key={row?.id}
                    sx={{ "& > *": { borderBottom: "unset" } }}
                    onClick={(event) => {
                      setDeceasedId(row?._id);
                      setOpenModal(true);
                    }}
                  >
                    <TableCellBody align="left"
                    >
                      <div className="user-cotainer-home -head pl-0 ml-0 ">
                        <div className="user-icon d-flex flex-row">
                          <Avatar
                            className="avatar"
                            style={{
                              height: "50px",
                              borderRadius: "6px",
                              width: "50px",
                            }}
                            alt={`yahrziet`}
                          >
                            <div className="name text-center">
                              {`${row?.firstName[0]}`.toUpperCase()}
                            </div>
                          </Avatar>
                        </div>
                        <div className="name-container flex-row-reverse">
                          <p
                            className="id-container w-100 table-field-hover-data text-left"
                            style={{ wordBreak: "break-word", whiteSpace: "nowrap" }}
                            title={row?.firstName}
                          >
                            {row?.firstName && row?.firstName}
                          </p>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" pl-0 ">
                        <div
                          style={{
                            color: "#3f4255",
                            fontWeight: "bolder",
                            fontSize: "14px",
                            fontFamily: fontConfig.MemberDetailsDeceasedTableListTextFont.family,
                            wordBreak: "break-word",
                            whiteSpace: "nowrap"
                          }}
                        >
                          {row?.lastName && row?.lastName}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className=" pl-0 ">
                        <div style={{ color: "grey" }}>
                          {row?.date_of_death
                            ? formatDate({ date: row?.date_of_death, formatType: "defaultWithUTC" })
                            : "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="w-100">
                        <div className="avatar-container my-0 pt-2">
                          <AvatarGroup max={4}>
                            {row &&
                              row?.mourners_list?.map((mourner, index) => {
                                if (mourner.observance === "english")
                                  return (
                                    <Tooltip
                                      title={
                                        mourner?.member_id?.first_name
                                          ? `${mourner?.member_id?.first_name} ${mourner?.member_id?.last_name}`
                                          : "Guest"
                                      }
                                    >
                                      <Avatar
                                        key={index}
                                        alt={mourner?.member_id?.first_name}
                                        src={
                                          mourner?.member_id?.profile_img &&
                                          mourner?.member_id?.profile_img
                                        }
                                      >
                                        {mourner?.member_id?.first_name &&
                                          mourner?.member_id?.last_name &&
                                          (
                                            mourner?.member_id.first_name[0] +
                                            mourner?.member_id.last_name[0]
                                          ).toUpperCase()}
                                      </Avatar>
                                    </Tooltip>
                                  );
                              })}
                          </AvatarGroup>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="user-cotainer-home pl-0 ml-0">
                        <div style={{ color: "grey" }}>
                          {row?.hebrew_date_of_death
                            ? row?.hebrew_date_of_death
                            : "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="w-100">
                        <div className="avatar-container my-0">
                          <AvatarGroup max={4}>
                            {row?.mourners_list?.map((mourner, index) => {
                              if (mourner.observance === "hebrew")
                                return (
                                  <Tooltip
                                    title={
                                      mourner?.member_id?.first_name
                                        ? `${mourner?.member_id?.first_name} ${mourner?.member_id?.last_name}`
                                        : "Guest"
                                    }
                                  >
                                    <Avatar
                                      key={index}
                                      alt={mourner?.member_id?.first_name}
                                      src={mourner?.member_id?.profile_img}
                                    >
                                      {mourner?.member_id?.first_name &&
                                        mourner?.member_id?.last_name &&
                                        (
                                          mourner?.member_id.first_name[0] +
                                          mourner?.member_id.last_name[0]
                                        ).toUpperCase()}
                                    </Avatar>
                                  </Tooltip>
                                );
                            })}
                          </AvatarGroup>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="user-cotainer-home pl-0 ml-0">
                        <div style={{ color: "grey" }}>
                          {row?.plaque_number ?? "-"}
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left" className="sticky-body-column"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div style={{ cursor: "pointer", paddingRight: "0px" }}>
                        <Action
                          style={{ color: "#4D5565", width: "16px" }}
                          onEditClick={() => {
                            setDeceasedId(row?._id);
                            setOpenModal(true);
                          }}
                          onDeleteClick={() => {
                            setDeceasedId(row?._id);
                            setOpen(true);
                          }}
                          onAddMournerClick={() => {
                            const filteredMourner = row?.mourners_list.map((item) => {
                              return {
                                ...item,
                                memberId: item?.member_id?._id,
                              };
                            });
                            setMournersList(filteredMourner);
                            setDeceasedId(row?._id);
                            setOpenAddMournerModal(true);
                          }}
                        />
                      </div>
                    </TableCellBody>
                  </TableRow>
                )
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="pagination-custom" style={{ marginTop: "20px" }}>
        <Pagination
          count={Math.ceil(total / 30)}
          color="primary"
          variant="outlined"
          onChange={(event, value) => {
            setPage(value - 1);
          }}
        />
      </div>
    </div>

  )
}

export default DeceasedTableList